import Component from '@ember/component';
import { action, computed, get, set } from '@ember/object';
import { service } from '@ember/service';

/*
  attrs
  - changeset
  - property
  - label (optional)
    - default is 'Contact'
  - showValidationErrors
  - focusOnInsert - if the input box should receive focus when it's inserted
  - disabled
  - showBlankContact
    - Whether to show a blank contact
    - This allows the user to 'unselect' a selected contact
    - default is false
  - blankContactLabel
    - Label for blank contact
    - default is 'None'
  - placeholder
    - Placeholder to show when a contact is not selected
    - default is 'Choose Contact'
  - onSelected
    - action to call when a contact is selected
*/
export default Component.extend({
  contactsCache: service(),

  classNames: ['form-group'],
  classNameBindings: ['hasErrors'],
  label: 'Contact',
  changeset: null,
  // the associated property on the changeset
  property: null,
  showBlankContact: false,
  blankContactLabel: 'None',
  placeholder: 'Choose Contact',
  showValidationErrors: false,
  focusOnInsert: false,
  disabled: false,
  hasErrors: computed(
    'showValidationErrors',
    'changeset.errors.[]',
    'property',
    function () {
      if (this.showValidationErrors === false) {
        return false;
      }

      let property = this.property;
      return (
        get(this, 'changeset.errors').find(function (item) {
          return get(item, 'key') === property;
        }) != null
      );
    },
  ),

  selectedContact: null,

  setSelectedContact() {
    let contact = null;
    let contactId = get(this, `changeset.${this.property}`);
    if (contactId) {
      contact = this.contactsCache.getById(contactId);
    }
    set(this, 'selectedContact', contact);
  },

  didReceiveAttrs() {
    this._super(...arguments);
    this.setSelectedContact();
  },

  handleContactSelected: action(function (contactId) {
    set(this, `changeset.${this.property}`, contactId);
    this.setSelectedContact();
    let onSelected = this.onSelected;
    if (onSelected) {
      onSelected(contactId);
    }
  }),
});
